export default __webpack_public_path__ + "static/media/nao_inviabilize.343f1e9a.png";